export type TourStepPlacement = 'auto' | 'top' | 'bottom' | 'left' | 'right';

/** Side-effect before highlighting a step (e.g. switch a multi-step wizard). */
export type TourStepActivate = {
  kind: 'deposit_wizard_step';
  step: 1 | 2 | 3;
};

export interface TourStep {
  id: string;
  targetTourId: string;
  title: string;
  description: string;
  placement?: TourStepPlacement;
  /** Run before resolving the target (wizard step switch, etc.). */
  activate?: TourStepActivate;
}

export type TourStatus = 'idle' | 'welcome' | 'running' | 'completed';

export const KIOSK_TOUR_ACTIVATE_EVENT = 'kiosk-tour-activate';

